import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "href", "className", "label", "primary", "isDark", "dark", "onClear"],
  _excluded2 = ["htmlProps"],
  _excluded3 = ["htmlProps"],
  _excluded4 = ["htmlProps"],
  _excluded5 = ["htmlProps"];
import { forwardRef, Fragment } from 'react';
import cn from 'classnames';
import CloseSmall from '@crehana/icons/outline/CloseSmall';
import parseClassnames from "../../helpers/parseClassnames";
import { primaryLight, primaryMain, secondaryLight, secondaryMain } from "../../styles/colors";
import { TAGS } from "../classnames";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * @deprecated
 * This component should not be used. Use Chip instead.
 */
var LinkTag = function LinkTag(_ref, ref) {
  var as = _ref.as,
    href = _ref.href,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    label = _ref.label,
    primary = _ref.primary,
    isDark = _ref.isDark,
    dark = _ref.dark,
    onClear = _ref.onClear,
    linkTagProps = _objectWithoutProperties(_ref, _excluded);
  var clearColor = isDark || dark ? secondaryLight : secondaryMain;
  if (primary) {
    clearColor = isDark || dark ? primaryLight : primaryMain;
  }
  var linkIndx = "".concat(primary ? 'primary-' : '').concat(isDark || dark ? 'dark' : 'light');
  var wrapperClassName = parseClassnames(className, cn(TAGS.link[linkIndx], href || linkTagProps.onClick ? 'cursor-pointer' : 'cursor-default', onClear ? 'pl-8' : 'px-8'));
  var renderChildren = function renderChildren() {
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [label, onClear && /*#__PURE__*/_jsx("button", {
        type: "button",
        className: "inline-flex items-center h-full pl-4 pr-8",
        onClick: onClear,
        children: /*#__PURE__*/_jsx(CloseSmall, {
          size: 16,
          color: clearColor
        })
      })]
    });
  };
  if (as === 'a' || href) {
    var _ref2 = linkTagProps,
      _htmlProps = _ref2.htmlProps,
      aProps = _objectWithoutProperties(_ref2, _excluded2);
    return /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread(_objectSpread({
      ref: ref,
      href: href,
      className: wrapperClassName
    }, _htmlProps), aProps), {}, {
      children: renderChildren()
    }));
  }
  if (as === 'button' || linkTagProps.onClick) {
    var _ref3 = linkTagProps,
      _htmlProps2 = _ref3.htmlProps,
      buttonProps = _objectWithoutProperties(_ref3, _excluded3);
    return /*#__PURE__*/_jsx("button", _objectSpread(_objectSpread(_objectSpread({
      ref: ref,
      type: "button",
      className: wrapperClassName
    }, _htmlProps2), buttonProps), {}, {
      children: renderChildren()
    }));
  }
  if (as === 'label') {
    var _ref4 = linkTagProps,
      _htmlProps3 = _ref4.htmlProps,
      labelProps = _objectWithoutProperties(_ref4, _excluded4);
    return /*#__PURE__*/_jsx("label", _objectSpread(_objectSpread(_objectSpread({
      ref: ref,
      className: wrapperClassName
    }, _htmlProps3), labelProps), {}, {
      children: renderChildren()
    }));
  }
  var _ref5 = linkTagProps,
    htmlProps = _ref5.htmlProps,
    spanProps = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_jsx("span", _objectSpread(_objectSpread(_objectSpread({
    ref: ref,
    className: wrapperClassName
  }, htmlProps), spanProps), {}, {
    children: renderChildren()
  }));
};
export default /*#__PURE__*/forwardRef(LinkTag);